export enum NotificationType {
    ORGANISATION = 'ORGANIZATION',
    GROUP="GROUP",
    COLLABORATION="COLLABORATION",
    SUBSCRIPTION="SUBSCRIPTION",
    PAYMENT="PAYMENT",
    PLAN="PLAN",
    FILE="FILE",
    PASSWORD="PASSWORD",
    LOGIN="LOGIN",
    ROLE_ADMIN="ROLE_ADMIN",
    ROLE_USER="ROLE_USER",
    ROLE="ROLE"
  }